import { http } from '../util/http'
import { fetchData } from '../util/index'
import { API_KOTLIN_DOMAIN, API_DOMAIN } from '../config'
import headers from './employeeSystemHeader'
import header from './headers'
//等级列表
export const fetchLevelList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-club/discount`,
  })
}

//删除
export const fetchDelLevel = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-club/discount/disable`,
    method: 'post',
    data,
  })
}
//修改
export const fetchEditLevel = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-club/discount/editLevel`,
    method: 'post',
    data,
  })
}
//新增等级列表
export const fetchAddLevel = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-club/discount/addLevel`,
    method: 'post',
    data,
  })
}

//等级
export function fetchGetLevel(params) {
  return http({
    headers: header(),
    url: `${API_KOTLIN_DOMAIN}/member/discount/member`,
    params,
  })
  // return (dispatch, getState) => {
  //   const endpoint = `${API_DOMAIN}/Manage/MemberApi/getLevel`
  //   return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
  //     dispatch(getClubLevel(data))
  //     return data
  //   })
  // }
}

export function fetchGetLevels(params) {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/member/discount/member`,
    params,
  })
}

//修改
export function setDiscount(data) {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/member/discount/setDiscount`,
    data,
    method: 'post',
  })
  // return (dispatch, getState) => {
  //   const endpoint = `${API_DOMAIN}/Manage/MemberApi/getLevel`
  //   return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
  //     dispatch(getClubLevel(data))
  //     return data
  //   })
  // }
}

// 获取会员折扣修改记录
export function fetchDiscountRecord(params) {
  return http({
    headers: header(),
    url: `${API_KOTLIN_DOMAIN}/member/discount/journal`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/setExpirationTime.js